import styled, { css } from "styled-components";
import type { SpaceProps } from "styled-system";
import { theme } from "../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { getDirection } from "../../../../../../common-deprecated/themes/common";

export const Overflower = styled.div`
    position: relative;
    width: 100%;
    height: 46px;
    margin: ${theme.space[0]};
    margin-bottom: ${theme.space[3]}px;
    overflow: hidden;
`;

export const OverFlowButton = styled.button<{ visible?: boolean }>`
    display: ${({ visible }) => (visible ? "block" : "none")};
    position: absolute;
    top: 0;
    width: 40px;
    height: 40px;
    color: ${theme.colors.grey4};
    background: ${theme.colors.lightest};
    z-index: ${theme.zIndex.gradesNav - 1};
    span {
        position: absolute;
        top: 3px;
        margin: ${theme.space[0]};
        padding: ${theme.space[0]};
    }
    &:hover {
        color: ${theme.colors.grey4};
    }
`;

export const LeftButton = styled(OverFlowButton)`
    ${getDirection("left")}: 0;
    span {
        ${getDirection("left")}: 0;
    }
`;

export const RightButton = styled(OverFlowButton)`
    ${getDirection("right")}: 0;
    span {
        ${getDirection("right")}: 0;
    }
`;

export const Wrapper = styled.div`
    position: relative;
    min-width: 100%;
    height: 100%;
    white-space: nowrap;
    border-bottom: 1px solid ${theme.colors.grey2};
    vertical-align: middle;
`;

export const Tab = styled.button<{ isActive?: boolean } & SpaceProps>`
    display: flex;
    position: relative;
    align-items: center;
    width: auto;
    min-width: 0;
    max-width: 100%;
    margin-bottom: ${theme.space[0]};
    margin-${getDirection("left")}: ${theme.space[4]}px;
    padding-bottom: ${theme.space[2]}px;
    font-family: ${theme.fonts.regular};
    font-size: 1.4rem;
    text-align: center;
    text-transform: uppercase;
    color: ${theme.colors.grey3};
    white-space: nowrap;
    background-color: transparent;
    border: none;
    &:first-child {
        margin-${getDirection("left")}: 0;
    }
    ${({ isActive }) =>
        isActive &&
        css`
            color: ${theme.colors.grey4};
            &::after {
                position: absolute;
                bottom: -1px;
                ${getDirection("left")}: 0;
                width: 100%;
                height: 1px;
                background: ${theme.colors.black};
                content: "";
            }
        `};
`;

export const Tabcount = styled.span<{ isActive?: boolean } & SpaceProps>`
    display: inline-block;
    margin-top: -1px;
    margin-${getDirection("left")}: ${theme.space[1]}px;
    font-family: ${theme.fonts.book};
    font-size: 1.3rem;
    color: ${theme.colors.grey3};
    ${({ isActive }) =>
        isActive &&
        css`
            color: ${theme.colors.grey4};
        `};
`;
